import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let on = true;
    // Only check session on admin routes to avoid 401 console noise on public pages
    const isAdminRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
    const hasToken = typeof window !== "undefined" && !!localStorage.getItem("sid_token");
    if (!isAdminRoute && !hasToken) {
      setLoading(false);
      return () => { on = false; };
    }
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (on) setUser(data);
      } catch (_) {
        if (on) setUser(null);
      } finally {
        if (on) setLoading(false);
      }
    })();
    return () => {
      on = false;
    };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) localStorage.setItem("sid_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* noop */ }
    localStorage.removeItem("sid_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
